// import moment from 'moment-timezone';
import { api } from '@/f1/service';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import Language from './language';
import _ from 'lodash';

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  sk : '', sv : '', skt : '', opt : { },
  created_at_ed : moment().add(1, 'day'),
  created_at_sd : moment().add(-1, 'month'),
})

export default {
  components: { DatePicker, Language },
  data: () => { return { moment, custom, so : default_opt() } },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields : function() {
      return [
        { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%' },
        { key: 'agent', label: 'Agent', sortable: true, thStyle: 'width: 30%' },
        { key: 'scan_folder', label: 'Check Folder', sortable: true },
        { key: 'scan_count', label: 'Check File', sortable: true },
        { key: 'detect_count', label: 'Detect Count', sortable: true },
        { key: 'scan_time', label: 'Check Time', sortable: true },
        // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    fields_ko : function() {
      return [
        { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%' },
        { key: 'agent', label: '에이전트', sortable: true, thStyle: 'width: 30%' },
        { key: 'scan_folder', label: '점검 폴더', sortable: true },
        { key: 'scan_count', label: '점검 파일', sortable: true },
        { key: 'detect_count', label: '탐지 수', sortable: true },
        { key: 'scan_time', label: '점검 일시', sortable: true },
        // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
      ]
    }
  },
  methods: {
    reset() { this.so = default_opt(); this.$refs._list.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh();},
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'result', cmd : 'list',
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : this.so.created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { so.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }

      return api.wsfinder.WSFinder(so).then(rs => {
        this.so.totalRows = rs.total;
        _.forEach(rs.body, x => {
          let sec = moment(x.created_at).diff(moment(x.scan_time), 'seconds')
          x.scanning_time =  `${Math.floor(sec / 60) < 0 ? 0 : Math.floor(sec / 60)}:${`${sec % 60 < 0 ? 0 : sec % 60}`.padStart(2, '0')}`
        })
        return rs.body
      }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    detail: function(item) { this.$router.push(`result/${item.id}`); },
  	hideList: function(e) {
      this.show = !e; console.log('Result.List.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created: function() {   console.log('Result.List.vue', 'created'); },
  destroyed: function() { console.log('Result.List.vue', 'destroyed'); },
  mounted: function() { console.log('Result.List.vue', 'mounted'); },
}
